// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import firebase from 'firebase';

import App from './App';
import router from './router';

Vue.use(Buefy);

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: 'AIzaSyCg8lWN8h77cUh5_qfQsZCinNbgxBzHQqw',
  authDomain: 'helixchart-63c08.firebaseapp.com',
  databaseURL: 'https://helixchart-63c08.firebaseio.com',
  projectId: 'helixchart-63c08',
  storageBucket: 'helixchart-63c08.appspot.com',
  messagingSenderId: '1064820159507',
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created() {
    firebase.initializeApp(firebaseConfig);
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$router.push('/projects');
      } else {
        if (document.location.hash === '#/sign-up') {
          this.$router.push('/sign-up');
        } else {
          this.$router.push('/login');
        }
      }

    });
  },
});



// WEBPACK FOOTER //
// ./src/main.js